import timesheetStructureItemsService from "presentation/services/timesheet-structure-items";


// Timesheet Structure Items methods
// Carrega um item no state
export const loadTimesheetStructureItem = (key, component) => {
    const { timesheetStructureItems } = component.state;
    let output = undefined;

    if (timesheetStructureItems.length > 0) {
        var item = timesheetStructureItems.find(x => { return x.key == key });
        output = item !== undefined ? item : undefined;
    }

    return output;
}

// Monta a lista no state
export const mountItems = (component) => {

    const { totalItems, timesheetStructureItems } = component.state;

    const deleteRequested = timesheetStructureItems.filter(x => x.isDeleteRequested === true);

    let newTimesheetStructureItems = [];

    for (let i = 0; i < totalItems; i++) {

        let itemKey = i + 1;

        //Default values

        let defaultItemName = '';
        let defaultDurationInMinutes = undefined;
        let defaultItemId = null;
        let defaultParentId = null;

        let itemName = defaultItemName;
        let itemDurationInMinutes = defaultDurationInMinutes;
        let itemId = defaultItemId;
        let itemParentId = defaultParentId;

        let timesheetStructureItem = loadTimesheetStructureItem(itemKey, component);

        if (timesheetStructureItem !== undefined) {
            itemName = timesheetStructureItem['name'] || defaultItemName;
            itemDurationInMinutes = timesheetStructureItem['durationInMinutes'] || defaultDurationInMinutes;
            itemId = timesheetStructureItem['id'] || defaultItemId;
            itemParentId = timesheetStructureItem['timesheetStructureId'] || defaultParentId;
        }

        newTimesheetStructureItems.push({
            key: itemKey,
            id: itemId,
            timesheetStructureId: itemParentId,
            name: itemName,
            durationInMinutes: itemDurationInMinutes,
            orderNumber: i
        });
    }

    let finalTimesheetStructureItems = [...newTimesheetStructureItems, ...deleteRequested];

    component.setState({ timesheetStructureItems: finalTimesheetStructureItems });
}

//Carrega as informações de um campo específico do item no state
export const timesheetStructureItemsFormValue = (key, formField, component) => {

    let output = undefined;

    var item = loadTimesheetStructureItem(key, component);

    output = item !== undefined ? item[formField] : undefined;

    return output;

}

//Tratativas para quando um campo muda de valor (geral)
export const handleChangeTimesheetStructureItems = (key, event, component) => {
    const { value, checked, type } = event.target;

    const name = event.target.getAttribute('data-field-name');

    const changeValue = type == "checkbox" ? checked : value;

    handleFieldChange(key, name, changeValue, component);
}


//Método genérico para acompanhar tratativas de mudança de valor dos campos
export const handleFieldChange = (key, field, value, component) => {
    var item = loadTimesheetStructureItem(key, component);

    item[field] = value;

    const newTimesheetStructureItems = changeTimesheetStructureItemsList(component, item);

    let finalOptions = beforeChangeTimesheetStructureItemsState(key, field, value, newTimesheetStructureItems, component);

    component.setState({
        timesheetStructureItems: finalOptions
    });
}

//Método para executar tratamentos antes da mudança para o novo state do formulário
export const beforeChangeTimesheetStructureItemsState = (key, changedField, changeValue, newTimesheetStructureItems, component) => {
    const { form } = component.state;
    let output = newTimesheetStructureItems;

    return output;
}

//Prapara o objeto do state para a atualização com as informações das alternativas da questão
export const changeTimesheetStructureItemsList = (component, targetOption, remove = false) => {
    let { timesheetStructureItems } = component.state;

    let optionIndex = timesheetStructureItems.findIndex(option => option.key == targetOption.key);

    if (remove === true) {
        let elementId = timesheetStructureItems[optionIndex]['id'] || undefined;

        if (elementId) {
            timesheetStructureItems[optionIndex]['isDeleteRequested'] = true;
            timesheetStructureItems[optionIndex]['key'] = 'delete-requested-' + new Date().getTime();
        } else {
            timesheetStructureItems.splice(optionIndex, 1);
        }
    } else {
        timesheetStructureItems[optionIndex] = targetOption;
    }

    return timesheetStructureItems;
}


//Prepara as requisições para administrar as alternativas das questões
export const prepareItemsRequests = (timehseetStructureEntity, timesheetStructureItemsData) => {
    let promises = undefined;
    let requests = [];
    timesheetStructureItemsData.map((e, index) => {

        let postData = {
            timesheetStructureId: timehseetStructureEntity.id
        };

        if (e.id) {
            postData.id = e.id;
            postData.insertAt = e.insertAt;

            if (e.isDeleteRequested) {
                postData.isDeleteRequested = true;
            }
        }
        postData = {
            ...postData,
            name: e.name,
            durationInMinutes: e.durationInMinutes,
            order: e.orderNumber
        }

        requests.push(postData);

    });

    if (requests.length > 0) {
        promises = requests.map(async (element, index) => {
            //Salva os dados da progressão
            if (element['isDeleteRequested']) {
                await timesheetStructureItemsService.remove(element['id']);
            } else {
                await timesheetStructureItemsService.save(element);
            }
        });
    };

    return promises;

}


const timesheetStructureItemsFunctions = {
    prepareItemsRequests,
    loadTimesheetStructureItem,
    timesheetStructureItemsFormValue,
    handleChangeTimesheetStructureItems,
    beforeChangeTimesheetStructureItemsState,
    changeTimesheetStructureItemsList,
    mountItems
}

export default timesheetStructureItemsFunctions;